import { css } from "@emotion/css";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import { groupBy } from "lodash";
import { useTranslation } from "react-i18next";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";

import { FormControlLabel } from "../../Default/LekUI/Checkbox";
import Filter from "./DefaultFilters";

export default function TermsFilter(props) {
	const { t } = useTranslation();

	const keySelected = (key, id) => {
		return props.selectedData[key].some((sd) => sd.id === id);
	};

	const setSelectedTerm = (term) => {
		const { selectedData } = props;
		if (keySelected("terms", term.id)) {
			props.setSelectedData({
				terms: selectedData.terms.filter(({ id }) => term.id !== id),
			});
		} else {
			props.setSelectedData({ terms: [...selectedData.terms, term] });
		}
	};

	const renderTerms = (terms) => {
		return terms.map((term) => (
			<FormControlLabel
				labelClassName={css`
          width: 64px;
        `}
				key={term.id}
				onChange={() => setSelectedTerm(term)}
				checked={keySelected("terms", term.id)}
				value={term.id}
				label={term.year}
				Control={<Checkbox />}
			/>
		));
	};

	const checkAll = (terms) => {
		const checkedAll = !terms.some(
			(term) => !props.selectedData.terms.some((st) => st.id === term.id),
		);
		if (!checkedAll) {
			props.setSelectedData({ terms: [...props.selectedData.terms, ...terms] });
		} else {
			props.setSelectedData({
				terms: props.selectedData.terms.filter(
					(term) => !terms.some((t) => t.id === term.id),
				),
			});
		}
	};

	const renderSemester = (terms, text) => {
		const checked = !terms.some(
			(term) => !props.selectedData.terms.some((st) => st.id === term.id),
		);
		const indeterminate =
			!checked &&
			terms.some((term) =>
				props.selectedData.terms.some((st) => st.id === term.id),
			);

		return (
			<div className="flex flex-1 flex-col">
				<MUIFormControlLabel
					label={text}
					control={
						<Checkbox
							className="checkbox"
							checked={checked}
							onChange={() => checkAll(terms)}
							indeterminate={indeterminate}
						/>
					}
				/>
				<div className="flex flex-wrap gap-8">{renderTerms(terms)}</div>
			</div>
		);
	};

	const renderFilters = () => {
		const terms = groupBy(props.terms, (term) => term.session);

		return (
			<div className="flex gap-8">
				{Object.entries(terms).map(([key, values]) => {
					return renderSemester(values, key);
				})}
			</div>
		);
	};

	return (
		<Filter
			{...props}
			title={t("filters.exams.terms.title")}
			renderFilterDetails={renderFilters}
		/>
	);
}
